export const pt = {
  title: 'Paisagens de Floresta Intacta',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Função',
      value:
        'Identifica as últimas paisagens florestais não fragmentadas remanescentes do mundo, grandes o bastante para reter toda a biodiversidade nativa e sem exibir sinais de alteração humana até o ano de 2020. Esta camada também exibe a redução na extensão de Paisagens Florestais Intactas de 2000 a 2020.',
    },
    {
      label: 'Resolução',
      value: 'Aproximadamente 1:1.000.000',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Global',
    },
    {
      label: 'Fonte',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer, and E. Esipova. 2017. "The last frontiers of wilderness: Tracking loss of intact forest landscapes from 2000 to 2013." Science Advances 3: e1600821.',
    },
    {
      label: 'Dados de conteúdo',
      value: 2020,
    },
    {
      label: 'Precauções',
      value:
        'O mapa IFL mundial foi criado através da interpretação visual de imagens da Landsat por especialistas. O mapa pode conter imprecisões devido a limitações na resolução espacial das imagens e pela falta de informações auxiliares sobre as práticas de uso da terra locais em algumas regiões. Além disso, a metodologia pressupõe que as queimadas na proximidade de estradas ou outras infraestruturas podem ter sido causados por seres humanos e, portanto, constituem uma forma de perturbação antrópica. Essa hipótese poderia resultar em uma subestimação da extensão da IFL no bioma boreal.',
    },
    {
      label: 'Licença',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Visão geral',
    value:
      'O conjunto de dados da Paisagens de Florestas Intactas (IFL) identifica extensões ininterruptas de ecossistemas naturais dentro da extensão de zona florestal que não mostram sinais significantes de atividade humana e que são grandes o suficiente para que toda a biodiversidade natural, incluindo populações viáveis de uma vasta gama de espécies, possam ser mantidas. Para mapear as áreas IFL, um conjunto de critérios foi desenvolvido e projetado para ser aplicado globalmente e facilmente reproduzido, para possibilitar que analises repetidas e verificações sejam feitas com o tempo. Áreas IFL foram definidas como paisagens não fragmentadas, de ao menos 50.000 hectares em tamanho, e uma amplitude mínima de 10 quilômetros. Estas, então, foram mapeadas usando imagens do satélite Landsat do ano de 2000.',
  },
  citation: {
    label: 'Citação',
    value:
      'Greenpeace, University of Maryland, World Resources Institute and Transparent World. “Intact Forest Landscapes. 2000/2013/2016/2020” Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org',
  },
};
